import { render, staticRenderFns } from "./TotalNum.vue?vue&type=template&id=5367282a&scoped=true&"
import script from "./TotalNum.vue?vue&type=script&lang=js&"
export * from "./TotalNum.vue?vue&type=script&lang=js&"
import style0 from "./TotalNum.vue?vue&type=style&index=0&id=5367282a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367282a",
  null
  
)

export default component.exports